<button 
  class="go-on-top" 
  (click)="scrollToTop()" 
  *ngIf="showGoTop"
><i class="material-icons">arrow_upward</i></button>
<router-outlet></router-outlet>
